import {
  IPerformerData,
  IPerformerDataActiveEvents,
  IPerformerDataActiveTypeticketcollections,
  IPerformerMetadata,
} from 'meta/pages/v4/performer'
import { SliceSelector } from 'store/types'

import { getPerformerKey } from '../_utils'

const getPerformerDetails: SliceSelector<IPerformerData | undefined, { id: string; language: string }> =
  ({ id, language }) =>
  (state) =>
    state.pages.performer[getPerformerKey({ id, language })]?.details

const getPerformerBulkDetails: SliceSelector<IPerformerData[] | undefined, { codes: string[]; language: string }> =
  ({ codes, language }) =>
  (state) => {
    return codes
      .map((code) => state.pages.performer[getPerformerKey({ id: code, language })]?.details)
      .filter(Boolean) as IPerformerData[]
  }

const getPerformerActiveEvents: SliceSelector<
  | {
      data: Record<number, IPerformerDataActiveEvents>
      metadata: IPerformerMetadata
    }
  | undefined,
  { id: string; language: string }
> =
  ({ id, language }) =>
  (state) =>
    state.pages.performer[getPerformerKey({ id, language })]?.activeEvents

const getPerformerActiveTypeticketcollections: SliceSelector<
  | {
      data: Record<number, IPerformerDataActiveTypeticketcollections>
      metadata: IPerformerMetadata
    }
  | undefined,
  { id: string; language: string }
> =
  ({ id, language }) =>
  (state) =>
    state.pages.performer[getPerformerKey({ id, language })]?.activeTypeticketcollections

const getPerformerMetadata: SliceSelector<object | undefined, { id: string; language: string }> =
  ({ id, language }) =>
  (state) =>
    state.pages.performer[getPerformerKey({ id, language })]?.metadata

export const PerformerSelectors = {
  getPerformerDetails,
  getPerformerBulkDetails,
  getPerformerActiveEvents,
  getPerformerActiveTypeticketcollections,
  getPerformerMetadata,
}
